module.exports = __webpack_public_path__ + "images/splt.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/splt.png
// module id = 126
// module chunks = 0